import { createEntityAdapter } from '@reduxjs/toolkit';
import { MarketingWithRevenueDTO } from '../types';

const marketingAdapter = createEntityAdapter<MarketingWithRevenueDTO>({});
export default marketingAdapter;
